import type { OAuthStatusResponse } from '@firestore-gui/shared';

/** Whether the setup flow should be shown (user is OAuth connected). */
export function isOAuthConnected(oauthStatus: OAuthStatusResponse | null): boolean {
  return oauthStatus?.status === 'connected';
}
